import { $, $$, isNotMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-recommender]')) return;
  addEventListeners();
}

function addEventListeners() {
  recommenderNavigation();
  recommenderDatalayer();
}

function recommenderNavigation() {
  const recommenderTriggers = $$('[data-au-recommender-trigger]');
  recommenderTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (trigger.dataset.auRecommenderShow.includes('./')) {
        window.location = trigger.dataset.auRecommenderShow;
      }

      const hide = $(`[data-au-recommender-content=${trigger.dataset.auRecommenderHide}`),
        hideInputs = hide?.querySelectorAll('input'),
        show = $(`[data-au-recommender-content=${trigger.dataset.auRecommenderShow}`),
        showInputs = show?.querySelectorAll('input');
      hide?.classList.add('au-hide');
      hideInputs.forEach((input) => {
        input.required = false;
      });
      show?.classList.remove('au-hide');
      showInputs.forEach((input) => {
        input.required = true;
      });

      const button = show.querySelector('[data-au-recommender-button]');
      if (button) {
        let validInputs = 0;
        showInputs.forEach((input) => {
          input.addEventListener('input', () => {
            validInputs = 0;
            showInputs.forEach((input) => {
              if (input.validity.valid) validInputs++;
            });

            // inputs block on cards recommender
            if (input.closest('[data-au-recommender-inputs-block]') && validInputs > 0) {
              button.disabled = false;
            } else if (validInputs === showInputs.length) button.disabled = false;
            else button.disabled = true;
          });
        });
      }

      if (show.classList.contains('au-recommender__main--narrow') && isNotMobile.matches) {
        const image = $('[data-au-recommender-image]');
        image.classList.remove('au-hide');
      }

      // focus on the data-au-recommender-form when show new step for a better user experience and accessibility
      const recommenderForm = trigger.closest('[data-au-recommender-form]');
      if (recommenderForm) recommenderForm.focus(); // Se enfoca el contenedor
    });
  });
}

function recommenderDatalayer() {
  // Function to push data to the dataLayer when showing/load a new step
  $$('[data-au-recommender-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const show = $(`[data-au-recommender-content=${trigger.dataset.auRecommenderShow}`);
      if (!show || !show?.querySelector('[data-recommender-current-step]')) return;
      const currentStep = show?.querySelector('[data-recommender-current-step]').textContent;
      const stepTitle = trigger
        .closest('[data-au-recommender-content]')
        .querySelector('[data-au-recommender-step-title]').innerText;
      const recommender = trigger.closest('[data-au-recommender]');

      let content_type;

      if (recommender.hasAttribute('data-au-franchising-recommender')) {
        content_type = 'flujo_recomendadorFranquicias';
      } else if (recommender.hasAttribute('data-au-cards-recommender')) {
        content_type = 'flujo_recomendadorTarjetas';
      } else if (recommender.hasAttribute('data-au-lubes-recommender')) {
        content_type = 'flujo_guiaLubes';
      } else {
        content_type = 'flujo_recomendador';
      }

      window.dataLayer.push({
        event: 'navigation',
        content_type,
        item_id: `${removeAccentMarkAndUppercase(currentStep)}_${removeAccentMarkAndUppercase(stepTitle)}`,
      });
    });
  });

  // Function to push data to the dataLayer when back or next buttons are clicked for lubes or cards recommenders
  $$('[data-au-recommender-step-navigation]').forEach((button) => {
    button.addEventListener('click', (e) => {
      const target = e.target;
      const content_type = target.dataset.auRecommenderStepNavigation === 'back' ? 'clickEnlace' : 'clickBoton';
      const titleText = target
        .closest('[data-au-recommender-content]')
        .querySelector('[data-au-recommender-step-title]').innerText;
      const clickText = target.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;
      window.dataLayer.push({
        event: 'navigation',
        content_type,
        item_id,
      });
    });
  });

  // Function to push data to the dataLayer when click on lubes or cards recommender. Not used for franchising recommender and not used for radio type segmented controls
  $$('[data-au-recommender]:not([data-au-franchising-recommender]) [data-au-segmented-control]').forEach((card) => {
    card.addEventListener('click', (e) => {
      const cardText = e.currentTarget.querySelector('[data-au-segmented-control-title]').innerText;
      const stepTitle = e.currentTarget
        .closest('[data-au-recommender-content]')
        .querySelector('[data-au-recommender-step-title]').innerText;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id: `${removeAccentMarkAndUppercase(stepTitle)}_${removeAccentMarkAndUppercase(cardText)}`,
      });
    });
  });
}

export default { init };
